import { createSlice } from "@reduxjs/toolkit";

// The student's currently selected courses, set from the header course
// filter. [] = "All Courses" (no narrowing). Any student page can read
// this via selectSelectedCourseIds to filter what it shows.
const initialState = {
  selectedCourseIds: [],
};

const studentCourseFilterSlice = createSlice({
  name: "studentCourseFilter",
  initialState,
  reducers: {
    setSelectedCourseIds: (state, action) => {
      state.selectedCourseIds = action.payload;
    },
  },
});

export const { setSelectedCourseIds } = studentCourseFilterSlice.actions;
export const selectSelectedCourseIds = (state) =>
  state.studentCourseFilter.selectedCourseIds;

export default studentCourseFilterSlice.reducer;
